/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetMoneyPoolWithOptionsRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {GetMoneyPoolWithOptionsResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const getMoneyPoolWithOptions = (request: GetMoneyPoolWithOptionsRequest, options?: CashRequestOptions) => post<GetMoneyPoolWithOptionsRequest, GetMoneyPoolWithOptionsResponse>("/2.0/cash/get-money-pool-with-options", request, {...options, rejectOnError: true })